export default __webpack_public_path__ + "static/media/bank.a7543a5e.png";